import React, { useEffect, useState } from 'react';
import columns from '../../../columns/account.jsx';
import { Form, Dropdown, Select, Input } from 'antd';
import { useNavigate } from 'react-router-dom';
import TableWithSkeleton from '../../../components/table/TableWithSkeleton.jsx';
import Segmented from "../../../components/segmented/Segmented.jsx";
import { useSearchParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import { GetAllV2fxAccountApi, UpdateAccountLeverageApi, UpdateAccountPasswordApi, VerifyLoginPasswordApi, AddAccountbalanceApi, GetAllAccountTypeApi, UpdateMT5AccountACtypeApi } from '../../../api/request/account.js';
import moment from 'moment/moment.js';
import { GetAllTutorialsApi } from '../../../api/request/tutorials.js';
import ModalComponent from '../../../components/modals/ModalComponent.jsx';
import ConfirmationModal from '../../../components/modals/ConfirmationModal.jsx';
import LoadableButton from '../../../components/buttons/LoadableButton.jsx';
import toast from 'react-hot-toast';
import ReactPlayer from 'react-player'
import { useResponsive } from '../../../hooks/useResponsive.js';


export default function Accounts() {

  const navigate = useNavigate();
  const { isMobile } = useResponsive();

  const [leverageForm] = Form.useForm();
  const [passwordForm] = Form.useForm();
  const [actypeForm] = Form.useForm();
  const [balanceForm] = Form.useForm();
  const [loginPasswordForm] = Form.useForm();
  const primaryColor = (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim();
  const { userDetails } = useSelector(state => state.user);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState('Live Account');
  const [acfilter, setAcfilter] = useState('Approved');
  const [data, setData] = useState([]);
  const [tutorials, setTutorials] = useState();
  const [accounts, setAccounts] = useState([]);
  const [isOpenactypedForm, setIsOpenactypedForm] = useState(false)
  const items = [
    { key: '1', label: (<div onClick={() => setIsOpenLeverageForm(true)}>Leverage Management</div>) },
    { key: '2', label: (<div onClick={() => setIsOpenPasswordForm(true)}>Change Password</div>) },
    { key: '3', label: (<div onClick={() => setIsOpenAddbalanceForm(true)}>Add Balance</div>) }
  ];

  const allItem = [
    { key: '1', label: (<div onClick={() => setIsOpenLeverageForm(true)}>Leverage Management</div>) },
    { key: '2', label: (<div onClick={() => setIsOpenPasswordForm(true)}>Change Password</div>) },
    // { key: '3', label: (<div onClick={() => setIsOpenactypedForm(true)}>Update A/C Type</div>) },
  ];
  const [isOpenLeverageForm, setIsOpenLeverageForm] = useState(false);
  const [selectedLeverage, setSelectedLeverage] = useState(null);
  const [isOpenLeverageConfirm, setIsOpenLeverageConfirm] = useState(false);
  const [isLeverageFormLoading, setIsLeverageFormLoading] = useState(false);
  const [isbalanceFormLoading, setIsbalanceFormLoading] = useState(false);
  // const [leverageOptions, setLeverageOptions] = useState();
  // const [BalanceOptions, setBalanceOptions] = useState([{ value: 20, label: '20' }, { value: 50, label: '50' }, { value: 100, label: '100' }, { value: 200, label: '200' }, { value: 300, label: '300' }, { value: 400, label: '400' }, { value: 500, label: '500' }]);
  const [isOpenPasswordForm, setIsOpenPasswordForm] = useState(false);
  const [isPasswordFormLoading, setIsPasswordFormLoading] = useState(false);
  const [isOpenPasswordConfirmationModal, setIsOpenPasswordConfirmationModal] = useState(false);
  const [isOpenactypedConfirmationModal, setIsOpenactypeConfirmationModal] = useState(false);
  const [isLoadingPasswordConfirmation, setIsLoadingPasswordConfirmation] = useState(false);
  const [passwordValue, setPasswordValue] = useState(null);
  const [actypeValue, setActypeValue] = useState(null)
  const [isOpenAddbalanceForm, setIsOpenAddbalanceForm] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [tutorialsdetails, setTutorialsdetails] = useState({});
  const [isOpenModaldetails, setIsOpenModaldetails] = useState(false);
  const [actype, setActype] = useState([]);

  const { leverageOptions, BalanceOptions } = [{ value: 20, label: '20' }, { value: 50, label: '50' }, { value: 100, label: '100' }, { value: 200, label: '200' }, { value: 300, label: '300' }, { value: 400, label: '400' }, { value: 500, label: '500' }];

  const filterAccounts = (type) => {
    const isDemo = type === 'Demo Account';
    setAccounts(data.filter(account => account.isDemo === isDemo));
  };

  const getFilters = (tag) => {
    switch (tag) {
      case 'Pending':
        return "Pending";
      case 'Approved':
        return "Approved";
      case 'Declined':
        return "Declined";
      default:
        break;
    }
  }

  const getAccounts = async () => {
    try {
      let params = {
        FilterText: getFilters(acfilter),
        tradingAccountType: filter === "Live Account" ? 0 : 1,
      }
      setIsLoading(true);
      const { data } = await GetAllV2fxAccountApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {

            return {
              ...item,
              status: (item?.status == 'Approved' ? (<p className='uppercase font-bold text-[#2D9B63] text-sm'>{item?.status}</p>) : (
                <p className='uppercase font-bold text-[#ef6464] text-sm'>{item?.status}</p>
              )),
              balances: `$ ${item?.balance?.toFixed(2)}`,
              createdAt: item?.createdDate ? moment(item?.createdDate).format('DD-MM-YYYY LT') : null,
              action: item?.status == 'Approved' ? (<Dropdown
                onClick={() => setSelectedAccount(item)}
                menu={{ items: item.isDemo === true ? items : allItem }}
                placement="bottomLeft"
                arrow
                trigger={['click']}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={primaryColor} className="size-6 cursor-pointer">
                  <path fillRule="evenodd" d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 0 0-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 0 0-2.282.819l-.922 1.597a1.875 1.875 0 0 0 .432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 0 0 0 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 0 0-.432 2.385l.922 1.597a1.875 1.875 0 0 0 2.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 0 0 2.28-.819l.923-1.597a1.875 1.875 0 0 0-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 0 0 0-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 0 0-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 0 0-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 0 0-1.85-1.567h-1.843ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z" clipRule="evenodd" />
                </svg>
              </Dropdown>) : "--"
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    filterAccounts(filter);
  }, [data]);

  useEffect(() => {
    setSearchParams(`filter=${filter}`);
    filterAccounts(filter);
  }, [filter]);

  useEffect(() => {
    leverageForm.resetFields();
    passwordForm.resetFields();
  }, [isOpenLeverageForm, isOpenPasswordForm]);

  useEffect(() => {
    loginPasswordForm.resetFields();
  }, [isOpenPasswordConfirmationModal]);

  const handleLeverageManagement = (values) => {
    setSelectedLeverage(values?.leverage)
    setIsOpenLeverageConfirm(true);
  }

  const updateLeverage = async () => {
    try {
      setIsLeverageFormLoading(true);
      let params = {
        leverage: selectedLeverage,
        terminalID: selectedAccount?.terminalID
      }
      const { data } = await UpdateAccountLeverageApi(params);
      if (data?.success) {
        leverageForm.resetFields();
        getAccounts();
        setIsOpenLeverageForm(false);
        setIsOpenLeverageConfirm(false);
      }
      setIsLeverageFormLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsLeverageFormLoading(false);
    }
  }

  const updateActype = async () => {
    try {
      setIsPasswordFormLoading(true);
      let params = {
        ...actypeValue
      }
      const { data } = await UpdateMT5AccountACtypeApi(params);
      if (data?.success) {
        actypeForm.resetFields();
        getAccounts();
        setIsOpenactypedForm(false);
        setIsOpenactypeConfirmationModal(false);
      }
      setIsPasswordFormLoading(true);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsPasswordFormLoading(true);
    }
  }

  const AddbalanceForm = async (values) => {
    try {
      setIsbalanceFormLoading(true);
      let params = {
        ...values,
        terminalID: selectedAccount?.terminalID
      }
      const { data } = await AddAccountbalanceApi(params);
      if (data?.success) {
        balanceForm.resetFields();
        toast.success(data?.message);
        getAccounts();
        setIsOpenAddbalanceForm(false);
      }
      setIsbalanceFormLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsbalanceFormLoading(false);
    }
  }
  const TutorialType = {
    Dashboard: { id: 1, description: "Dashboard" },
    Inbox: { id: 2, description: "Inbox" },
    Accounts: { id: 3, description: "Accounts" },
    Deposit: { id: 4, description: "Deposit" },
    Withdraw: { id: 5, description: "Withdraw" },
    Transfer: { id: 6, description: "Transfer" },
    Transactions: { id: 7, description: "Transactions" },
    Tree: { id: 8, description: "Tree" },
    Support: { id: 9, description: "Support" },
    Trading: { id: 10, description: "Trading" },
  };
  // const getAllTutorials = async () => {
  //   try {
  //     setIsLoading(true);
  //     let params = {
  //       tutorialType: 3,
  //       ApplyPagination:false,
  //       SortBy: "createdDate"

  //     }
  //     const { data } = await GetAllTutorialsApi(new URLSearchParams(params).toString());
  //     if (data?.success) {
  //       setTutorials(data?.data);
  //     }
  //     setIsLoading(false);
  //   } catch (error) {
  //     setIsLoading(false);
  //   }
  // }
  const getAllTutorials = async (type) => {
    try {
      setIsLoading(true);

      // Access the ID for the tutorial type dynamically
      const tutorialType = TutorialType[type]?.id || 3; // Default to 3 (Accounts) if not found

      let params = {
        tutorialType: tutorialType,
        ApplyPagination: false,
        SortBy: "createdDate",
      };

      const { data } = await GetAllTutorialsApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setTutorials(data?.data);
      }
    } catch (error) {
      console.error("Failed to fetch tutorials", error);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (searchParams?.get('filter')) {
      setFilter(searchParams?.get('filter'));
    };
    // getAccounts();
    getAllTutorials()
    getContries();
  }, []);
  useEffect(() => {
    getAccounts();
  }, [filter, acfilter]);

  const handlePasswordUpdate = (values) => {
    setIsPasswordFormLoading(true);
    let params = {
      terminalID: selectedAccount?.terminalID,
      Password: values?.Password,
      investorPassword: values?.investorPassword,
    }
    setPasswordValue(params);
    setIsOpenPasswordConfirmationModal(true);
  }

  const handleACtypeUpdate = (values) => {
    setIsPasswordFormLoading(true);
    let params = {
      loginId: selectedAccount?.login,
      planId: values?.pType,

    }
    setActypeValue(params);
    setIsOpenactypeConfirmationModal(true);
  }

  const verifyPassword = async (values) => {
    try {

      setIsLoadingPasswordConfirmation(true);
      const { data } = await VerifyLoginPasswordApi(values);
      if (data?.success) {
        setIsOpenPasswordConfirmationModal(false);
        setIsLoadingPasswordConfirmation(false);
        loginPasswordForm.resetFields();
        return true;
      } else {
        return false;
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsLoadingPasswordConfirmation(false);
      return false;
    }
  }

  const handleLoginPassword = async (values) => {
    try {
      setIsPasswordFormLoading(true);
      let params = {
        password: values?.password,
        confirmPassword: values?.password,
        userId: userDetails.id,
      }

      if (await verifyPassword(params)) {
        const { data } = await UpdateAccountPasswordApi(passwordValue);
        if (data?.success) {
          toast.success(data?.message);
          passwordForm.resetFields();
          setIsOpenPasswordForm(false);
        }
        setIsPasswordFormLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsPasswordFormLoading(false);
    }
  }

  const addTutorialsModalHandler = (Item) => {
    setIsOpenModaldetails(true);
    setTutorialsdetails(Item)
  }

  const getContries = async () => {
    try {
      let apiParams = {
        userId: userDetails?.id,
        tradingAccountType: 0
      }
      const { data } = await GetAllAccountTypeApi(apiParams);
      if (data?.success) {
        setActype(
          data?.data?.map((item) => ({
            ...item,
            value: item?.planId,
            label: item?.planName,
          }))
        );

      }
    } catch (error) { }
  };

  return (
    <div>
      <div className='flex flex-wrap justify-between gap-5'>
        <div className={`ant-select-selector-white ${isMobile ? 'flex justify-center w-full ' : ''}`}>
          <Segmented options={['Live Account', 'Demo Account']} value={filter} setValue={setFilter} />
        </div>
        <div className={`flex flex-wrap sm:px-2 max-sm:space-y-5 ${isMobile ? 'w-full' : ''}`}>
          <div className={`flex flex-wrap justify-between gap-5 ${isMobile ? 'w-full' : ''}`}>
            {filter === 'Live Account' ? <div className={`ant-select-selector-white  ${isMobile ? 'flex justify-center w-full' : 'mr-4'}`}>
              <Segmented options={['Approved', 'Pending', 'Declined']} value={acfilter} setValue={setAcfilter} />
            </div> : ""}
          </div>
          {
            filter == 'Demo Account' ? (
              <button className={`bg-primary text-sm text-white font-semibold px-9 py-2 rounded-lg ${isMobile ? 'w-full' : ''}`} onClick={() => navigate('/account?type=demo')}>Open Demo Account</button>
            ) : (
              <button className={`bg-primary text-sm text-white font-semibold px-9 py-2 rounded-lg ${isMobile ? 'w-full' : ''}`} onClick={() => navigate('/account?type=live')}>Open Live Account</button>
            )
          }
        </div>
      </div>
      <div className='border border-gray-200 rounded-xl overflow-hidden bg-white my-6'>
        {/* <TableWithSkeleton columns={filter == 'Live Account' ? [...columns, action] : columns} data={accounts} loading={isLoading} /> */}
        <TableWithSkeleton columns={columns} data={accounts} loading={isLoading} />
      </div>

      {/* Leverage management form modal */}
      <ModalComponent isOpen={isOpenLeverageForm} setIsOpen={setIsOpenLeverageForm} title='Leverage Management'>
        <Form className='w-full' autoComplete="off" form={leverageForm} onFinish={handleLeverageManagement}>
          <div className='ant-select-selector-white'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Leverage</label>
            <Form.Item name='leverage' rules={[{ required: true, message: 'Please select leverage.' }]}>
              <Select className='border-primary w-full mt-1' placeholder='Select leverage' options={leverageOptions} />
            </Form.Item>
          </div>
          <div className='flex justify-center items-center gap-5 mt-10'>
            <button type='submit' className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500'>Proceed</button>
            <button type='button' className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500' onClick={() => setIsOpenLeverageForm(false)}>Cancel</button>
          </div>
        </Form>
      </ModalComponent>

      {/* Add balance form modal */}
      <ModalComponent isOpen={isOpenAddbalanceForm} setIsOpen={setIsOpenAddbalanceForm} title='Add balance'>
        <Form className='w-full' autoComplete="off" form={balanceForm} onFinish={AddbalanceForm}>
          <div className='ant-select-selector-white'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Balance</label>
            <Form.Item name='amount' rules={[{ required: true, message: 'Please select balance.' }]}>
              <Select className='border-primary w-full mt-1' placeholder='Select balance' options={BalanceOptions} />
            </Form.Item>
          </div>
          <div className='flex justify-center items-center gap-5 mt-10'>
            {/* <button type='submit' className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500'>Proceed</button> */}
            <LoadableButton
              className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
              disabled={isbalanceFormLoading}
              type="Submit"
              lable='Proceed'
              isLoading={isbalanceFormLoading}
              loadingLable='Updating amount...'
            />
            <button type='button' className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500' onClick={() => setIsOpenAddbalanceForm(false)}>Cancel</button>
          </div>
        </Form>
      </ModalComponent>

      {/* Leverage confirmation modal */}
      <ConfirmationModal
        isOpen={isOpenLeverageConfirm}
        setIsOpen={setIsOpenLeverageConfirm}
        message={`${selectedLeverage > selectedAccount?.leverage ? `You have chosen 1:${selectedLeverage} leverage with a high-risk level.` : ''} Leverage will affect the required margin. Are you sure you want to continue?`}
        onConfirm={updateLeverage}
        isLoading={isLeverageFormLoading}
        loadingLabel='Changing Leverage...'
      />

      {/* Update A/C type confirmation modal */}
      <ConfirmationModal
        isOpen={isOpenactypedConfirmationModal}
        setIsOpen={setIsOpenactypeConfirmationModal}
        message=" Are you sure you want to Update A/C type?"
        onConfirm={updateActype}
        isLoading={isLeverageFormLoading}
        loadingLabel='Changing Leverage...'
      />

      {/* Update password form modal */}
      <ModalComponent isOpen={isOpenPasswordForm} setIsOpen={setIsOpenPasswordForm} title='Change Password'>
        <Form className='w-full' autoComplete="off" form={passwordForm} onFinish={handlePasswordUpdate}>

          <div className='input-white mt-5'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Password</label>
            <Form.Item name='Password' hasFeedback rules={[{ required: true, message: 'Please enter new password.' }, {
              pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
              message: 'Please enter strong password.',
            },]}>
              <Input.Password type='password' placeholder="password" className="mt-1 w-full ps-4 py-2" />
            </Form.Item>
          </div>
          <div className='input-white mt-5'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Investor Password</label>
            <Form.Item name='investorPassword' dependencies={['investorPassword']} hasFeedback rules={[{ required: true, message: 'Please enter password.' }, {
              pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
              message: 'Please enter strong investor password.',
            },]}>
              <Input.Password type='password' placeholder="Investor Password" className="mt-1 w-full ps-4 py-2" />
            </Form.Item>
          </div>
          <div className='flex justify-center items-center gap-5 mt-10'>
            <LoadableButton
              className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
              disabled={isPasswordFormLoading}
              type="Submit"
              lable='Proceed'
              isLoading={isPasswordFormLoading}
              loadingLable='Updating password...'
            />
            <button type='button' className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500' onClick={() => setIsOpenPasswordForm(false)} disabled={isPasswordFormLoading}>Cancel</button>
          </div>
        </Form>
      </ModalComponent>


      {/* Update A/C Type form modal */}
      <ModalComponent isOpen={isOpenactypedForm} setIsOpen={setIsOpenactypedForm} title='Update A/C Type'>
        <Form className='w-full' autoComplete="off" form={actypeForm} onFinish={handleACtypeUpdate}>
          <div className='ant-select-selector-white'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>A/C Type</label>
            <Form.Item name='pType' rules={[{ required: true, message: 'Please select A/C type.' }]}>
              <Select className='border-primary w-full mt-1' placeholder='Select A/C type' options={actype} />
            </Form.Item>
          </div>

          <div className='flex justify-center items-center gap-5 mt-10'>
            <LoadableButton
              className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
              // disabled={isPasswordFormLoading}
              type="Submit"
              lable='Proceed'
              // isLoading={isPasswordFormLoading}
              loadingLable='Updating A/C type...'
            />
            <button type='button' className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500' onClick={() => setIsOpenactypedForm(false)} disabled={isPasswordFormLoading}>Cancel</button>
          </div>
        </Form>
      </ModalComponent>

      {/* Login password confirmation form modal */}
      <ModalComponent isOpen={isOpenPasswordConfirmationModal} setIsOpen={setIsOpenPasswordConfirmationModal} title='Verify login Password'>
        <Form className='w-full' autoComplete="off" form={loginPasswordForm} onFinish={handleLoginPassword}>
          {/* <div className='input-white mt-5'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Login Password</label>
            <Form.Item name='currentPassword' rules={[{ required: true, message: 'Please enter login password.' }]}>
              <Input.Password type='password' placeholder="Login password" className="mt-1 w-full ps-4 py-2" />
            </Form.Item>
          </div> */}
          <div className='input-white mt-5'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Password</label>
            <Form.Item name='password' hasFeedback rules={[{ required: true, message: 'Please enter password.' }, {
              pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
              message: 'Please enter strong password.',
            },]}>
              <Input.Password type='password' placeholder="Password" className="mt-1 w-full ps-4 py-2" />
            </Form.Item>
          </div>
          <div className='flex justify-center items-center gap-5 mt-10'>
            <LoadableButton
              className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
              disabled={isLoadingPasswordConfirmation}
              type="Submit"
              lable='Verify'
              isLoading={isLoadingPasswordConfirmation}
              loadingLable='Verifying password...'
            />
            <button type='button' className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500' onClick={() => setIsOpenPasswordConfirmationModal(false)} disabled={isLoadingPasswordConfirmation}>Cancel</button>
          </div>
        </Form>
      </ModalComponent>

      <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title='Tutorial' width={1000}>
        {tutorials && tutorials.length > 0 ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-5 mt-6">
            {tutorials?.map((item, index) => (
              <div
                key={index}
                className="shadow-lg cursor-pointer rounded-t-2xl overflow-hidden"
                onClick={() => addTutorialsModalHandler(item)}
              >
                <div className="relative pb-[56.25%] h-0">
                  {item.youtubeUrl ? (
                    <ReactPlayer
                      url={item.youtubeUrl}
                      className="absolute top-0 left-0 w-full h-full"
                      width="100%"
                      height="100%"
                      controls
                    />
                  ) : item.videoUrl ? (
                    <ReactPlayer
                      url={item.videoUrl}
                      className="absolute top-0 left-0 w-full h-full"
                      width="100%"
                      height="100%"
                      controls
                    />
                  ) : (
                    <p>Video not available</p>
                  )}
                </div>
                <div className="text-center p-4">
                  <p className="text-lg font-semibold line-limit-1">{tutorials?.title}</p>
                  <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">{tutorials?.description}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className='text-center'>
            <p className='text-lg font-semibold'>Video not available</p>
          </div>
        )}
      </ModalComponent>


      <ModalComponent isOpen={isOpenModaldetails} setIsOpen={setIsOpenModaldetails} title='Tutorial' width={800}>
        <div className="relative pb-[56.25%] h-0">

          {tutorialsdetails.youtubeUrl ? (
            <ReactPlayer
              url={tutorialsdetails.youtubeUrl}
              className="absolute top-0 left-0 w-full h-full"
              width="100%"
              height="100%"
              controls
            />
          ) : tutorialsdetails.videoUrl ? (
            <ReactPlayer
              url={tutorialsdetails.videoUrl}
              className="absolute top-0 left-0 w-full h-full"
              width="100%"
              height="100%"
              controls
            />
          ) : (
            <p>Video not available</p>
          )}

        </div>
        <div className="text-center p-4">
          <p className="text-lg font-semibold line-limit-1">{tutorialsdetails?.title}</p>
          <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">{tutorialsdetails?.description}</p>
        </div>
      </ModalComponent>
    </div>
  )
}
